export function isFullSizeImageProduct(product) {
    return product.productImageType === 'fullSize';
}
export function isTransparentImageProduct(product) {
    return product.productImageType === 'transparent';
}
export function filterProducts(products, isSubscriptionMode, activeCategory, activeSubCategory = null, filterOnSuppliers = false) {
    let productsToShow = [...products];
    if (isSubscriptionMode) {
        productsToShow = productsToShow.filter((product) => product.subscriptionProduct);
    }
    if (activeCategory) {
        if (filterOnSuppliers) {
            productsToShow = productsToShow.filter((product) => { var _a; return ((_a = product === null || product === void 0 ? void 0 : product.producer) === null || _a === void 0 ? void 0 : _a.id) == activeCategory.id; });
        }
        else {
            productsToShow = productsToShow.filter((product) => product.category.some((category) => category.id == activeCategory.id));
        }
    }
    if (activeSubCategory) {
        productsToShow = productsToShow.filter((product) => product.category.some((category) => category.id == activeSubCategory.id));
    }
    return productsToShow;
}
export function isProductSoldOut(stock, product) {
    return stock.productIdToQuantityPossible[product.id] <= 0 || product.soldOut === '1';
}
